import axios from 'axios'

// 18.178.15.72
export const axiosUrl = axios.create({
    // baseURL: 'https://d3ds006smdnqj1.cloudfront.net',
    // baseURL: 'https://twitclone.ap-northeast-1.elasticbeanstalk.com/api',
    // baseURL: 'https://d2kiqjef12ikki.cloudfront.net',
    // baseURL: 'https://twitclonebackend.herokuapp.com/api',
    baseURL: 'https://twitclonebackend.onrender.com/api',

    // httpsAgent
    withCredentials: true,
});

// export const axiosCredentials = axios.defaults.withCredentials = true